import { CONTACT } from "@/lib/brand";
import { Clock, MapPin, Car, ArrowUpRight } from "lucide-react";

const cards = [
  {
    icon: MapPin,
    title: "Address",
    lines: [
      "Booth No. 20, Pocket 4 Phase 2",
      "Omaxe, beside Gurudwara",
      "New Chandigarh, Punjab 140901",
    ],
    accent: "#299fe0",
  },
  {
    icon: Clock,
    title: "Store Timings",
    lines: [
      `${CONTACT.openDays}`,
      `${CONTACT.hoursOpen}`,
      `Lunch break: ${CONTACT.lunchBreak}`,
    ],
    accent: "#cb05a5",
  },
  {
    icon: Car,
    title: "Parking",
    lines: [
      "Easy market parking",
      "available directly outside",
      "the store.",
    ],
    accent: "#299fe0",
  },
];

export default function PlanVisit() {
  return (
    <section
      id="store"
      data-testid="plan-visit-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="inline-block text-xs tracking-[0.28em] uppercase font-semibold text-[#cb05a5]">
            Plan your visit
          </span>
          <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl text-slate-900 tracking-tight">
            Come see the collection in person.
          </h2>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">
            We&apos;re just a short walk from the Gurudwara — pop in during
            store hours, browse at your own pace, and let us help you find the
            perfect notebook or pen.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((c) => (
            <div
              key={c.title}
              data-testid={`plan-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="relative overflow-hidden rounded-3xl bg-white sb-hairline sb-shadow p-8 group hover:-translate-y-1 hover:sb-shadow-lg transition-all duration-300"
            >
              <div
                className="absolute -top-16 -right-16 w-40 h-40 rounded-full opacity-10 blur-2xl transition-opacity group-hover:opacity-25"
                style={{ background: c.accent }}
              />
              <div
                className="w-12 h-12 rounded-2xl flex items-center justify-center text-white"
                style={{ background: c.accent }}
              >
                <c.icon size={22} strokeWidth={2} />
              </div>
              <h3 className="mt-5 font-display font-bold text-2xl text-slate-900">
                {c.title}
              </h3>
              <div className="mt-3 space-y-1 text-slate-600 leading-relaxed">
                {c.lines.map((l, i) => (
                  <div key={i}>{l}</div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href={CONTACT.mapsUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="visit-us-today-btn"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-semibold transition-transform hover:-translate-y-0.5 shadow-lg"
            style={{
              background:
                "linear-gradient(135deg, #299fe0 0%, #cb05a5 130%)",
            }}
          >
            <MapPin size={18} />
            Visit Us Today
            <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
